import { useRef } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { KumoPortalProvider } from '@cloudflare/kumo/utils'
import { Toasty } from '@cloudflare/kumo/components/toast'
import { AuthProvider } from './contexts/AuthContext'
import App from './App'
import { appToastManager } from './lib/appToast'

export default function Root() {
  const portalRef = useRef(null)

  return (
    <>
      <div
        ref={portalRef}
        className="pointer-events-none fixed inset-0 z-[100] [&>*]:pointer-events-auto"
      />
      <KumoPortalProvider container={portalRef}>
        <Toasty toastManager={appToastManager}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </Toasty>
      </KumoPortalProvider>
    </>
  )
}
